import { useState } from "react";
import './AccountWidget.css';

const AccountWidget = ({ username, onClick, logout }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  let displayName;
  if(username != null)
  {
    displayName = username.length > 18 ? username.substring(0, 18) + '...' : username;
  }

  const handleClick = () => {
    if (username == null) {
      if (onClick) {
        onClick();
      }
      return;
    }

    setMenuOpen((prev) => !prev);
  };
  
  return (
    <div className="account-widget-wrapper">
      <button className="account-widget" onClick={handleClick}>
        <svg className="user-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M12,12.5c-3.04,0-5.5,1.73-5.5,3.5s2.46,3.5,5.5,3.5,5.5-1.73,5.5-3.5-2.46-3.5-5.5-3.5Zm0-.5c1.66,0,3-1.34,3-3s-1.34-3-3-3-3,1.34-3,3,1.34,3,3,3Z" />
        </svg>
        {
          username == null ? <span className="username">Login</span> : <span className="username">{displayName}</span>
        }
      </button>
      {username != null ? (
        <div className={`account-widget-menu ${menuOpen ? "account-widget-menu--open" : ""}`}>
          <button className="account-widget-menu__item" type="button" onClick={logout}>
            Logout
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default AccountWidget;